module.exports = __webpack_public_path__ + "images/magnf_glass.svg";